module.exports = __webpack_public_path__ + "static/media/17b-02_ST-2017-200x300cm-oleo-sobre-madera.937e6e93.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/17b/17b-02_ST-2017-200x300cm-oleo-sobre-madera.jpg
// module id = 208
// module chunks = 0